import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { usePurchasedGoodsItemsList } from '@shared/api/lib/purchased-goods/purchased-goods';
import {
  PurchasedGoodsItem,
  PurchasedGoodsItemsListParams,
} from '@shared/api/types';

/**
 * Searchable purchased goods for the insights item picker — a plain array,
 * capped server-side. `search` matches name and external ID; `item` narrows to
 * specific activity uuids (used to resolve labels for already-selected
 * values); the insights dimension and period params scope the results the same
 * way they scope the page.
 */
export const useGetPurchasedGoodsItemsList = (
  params?: PurchasedGoodsItemsListParams,
  options?: { enabled?: boolean }
) =>
  usePurchasedGoodsItemsList<readonly PurchasedGoodsItem[]>(params, {
    request: useAxiosConfig(),
    query: {
      keepPreviousData: true,
      enabled: options?.enabled,
    },
  });
